import { instanaReportError } from '@bizzabo/instana-api';
import { client, getIsOrganizerToken, Session } from '@bizzabo/entities';

export const joinToChannels = async (accountId: number, eventId: number, session: Session) => {
    try {
        if (getIsOrganizerToken()) {
            await client().post(
                `/api/v2/agenda/accounts/${accountId}/events/${eventId}/portal/sessions/${session.id}/chat/joinChannels`
            );
        } else {
            await client().post(
                `/api/v2/agenda/events/${eventId}/sessions/${session.id}/chat/joinChannels`
            );
        }
    } catch (error) {
        instanaReportError({ error });
    }
};
